import Box from '@mui/material/Box';
import type { ReactNode } from 'react';
import {
  ElementCategoryCard,
  ElementCategoryCardSkeleton,
} from '../../elements/ElementCategoryCard';
import type { CompetitionElementsData } from './data/api';

const CATEGORY_SKELETON_COUNT = 5;

interface CompetitionElementsCategoryRowProps {
  categories: CompetitionElementsData['categories'];
  loading: boolean;
  selected: string[];
  onToggle: (category: string) => void;
}

export function CompetitionElementsCategoryRow({
  categories,
  loading,
  selected,
  onToggle,
}: CompetitionElementsCategoryRowProps): ReactNode {
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 5, justifyContent: 'center' }}>
      {loading
        ? Array.from(
            { length: CATEGORY_SKELETON_COUNT },
            (_, index) => `category-skeleton-${index}`,
          ).map((id) => <ElementCategoryCardSkeleton key={id} />)
        : categories.map((category) => (
            <ElementCategoryCard
              key={category.category}
              category={{
                category: category.category,
                elementsCount: category.elements,
                tagsCount: category.tags,
                creativesCount: 0,
              }}
              selected={selected.includes(category.category)}
              onSelect={() => onToggle(category.category)}
            />
          ))}
    </Box>
  );
}
